module.exports = __webpack_public_path__ + "img/vnx.f7126b5e.png";